var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showHeaderFooter)?_c('Header'):_vm._e(),_c('gap',{attrs:{"height":51}}),_c('router-view'),(_vm.showHeaderFooter)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }